@let rows = data() ?? [];

<div class="w-full" [attr.data-testid]="id()">
  @if (isLoading()) {
    <div class="py-5">
      <aw-loading-animation />
    </div>
  } @else {
    @if (showHeader()) {
      <div
        class="border-tonal-outlined-border flex border-b text-base font-semibold *:flex *:flex-1 *:items-center *:justify-start"
        [ngClass]="density() === 'compact' ? '*:p-2' : '*:p-3'"
        [attr.data-testid]="id() | appendTestId: 'header'">
        <ng-container *ngTemplateOutlet="header()" />
      </div>
    }

    @for (
      dataPoint of rows;
      track rowKey(dataPoint, $index);
      let index = $index
    ) {
      <div
        class="border-standard-divider flex"
        [class.hidden]="!rowIsVisible(dataPoint)"
        [ngClass]="[
          density() === 'compact' ? 'min-h-12 py-1' : 'min-h-16 py-4',
          applyDefaultCellStyles()
            ? density() === 'compact'
              ? '*:flex *:flex-1 *:items-center *:justify-start *:px-2 *:py-1'
              : '*:flex *:flex-1 *:items-center *:justify-start *:p-3'
            : '',
        ]"
        [class.border-b]="index < rows.length - 1 || showLastRowBorder()"
        [attr.data-testid]="id() | appendTestId: 'row-' + index">
        <ng-container
          *ngTemplateOutlet="
            columns();
            context: {
              $implicit: dataPoint,
              data: dataPoint,
              index: index,
            }
          " />
      </div>
    } @empty {
      <div
        class="flex justify-center p-4"
        [attr.data-testid]="id() | appendTestId: 'noEntries'">
        {{ cmsTextProvider.shared.noDataFound }}
      </div>
    }
  }
</div>
